<form novalidate>
    <div class="draggable"
        cdkDropList 
        id="parent-drop-list"
        [cdkDropListData]="visibleItems"
        (cdkDropListDropped)="onDrop($event)">
        <div *ngFor="let item of visibleItems; let i = index"
             cdkDrag
             [cdkDragData]="item"
             [cdkDragDisabled]="item.disabled"
             class="parent-drag-wrapper">
            <itemconfiglistitem  
                [item]="item" 
                [items]="item.children" 
                [dropdownOptions]="dropdownOptions"
                [depth]="0" 
                [hideDisableItems]="hideDisableItems" 
                id="{{item.id}}" 
                attr.parentId="{{item.parentId}}" 
                (itemDeleted)="onItemDeleted(item)"
                (itemSaved)="save()"
                (addEvent)="addSibling($event)">
            </itemconfiglistitem>
        </div>
    </div>
</form>




